<div class="project-dashboard">
  @if (mobileNavOpen) {
  <div class="mobile-nav-overlay" (click)="closeMobileNav()"></div>
  }

  <!-- Left Sidebar (light) -->
  <aside class="project-sidebar" [class.mobile-open]="mobileNavOpen" [class.collapsed]="sidebarCollapsed">
    <!-- Floats over the sidebar, positioned relative to .project-sidebar (not the
         overflow-y:auto .sidebar-scroll below) so it never adds to that container's
         scrollable content box and can't trigger an overflow-x scrollbar. -->
    <button type="button" class="sidebar-home__toggle" [class.collapsed]="sidebarCollapsed" (click)="toggleSidebar()"
      [attr.aria-label]="sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'">
      <lucide-icon name="chevron-left" />
    </button>

    <!-- Scrollable nav area — isolated so overflow-y:auto doesn't clip the user-footer dropdown -->
    <div class="sidebar-scroll">

      <div class="sidebar-home">
        <div class="sidebar-home__header">
          <a routerLink="/dashboard" class="sidebar-home__logo-link">
            <img src="/assets/logos/declunk-horizontal-purple-black.svg" alt="Declunk"
              class="sidebar-home__logo sidebar-home__logo--full">
            <img src="/favicon.png" alt="" aria-hidden="true" class="sidebar-home__logo sidebar-home__logo--icon">
          </a>
        </div>

        <!-- Sidebar -->
        <nav class="side-nav">
          <button class="nav-item" [class.active]="activeNav === 'dashboard'" (click)="setActiveNav('dashboard')"
            (mouseenter)="showNavTooltip($event, 'Dashboard')" (mouseleave)="hideNavTooltip()">
            <lucide-icon name="layout-dashboard" [size]="18" class="nav-ic" />
            <span class="nav-label">Dashboard</span>
          </button>
          <div class="nav-item-wrap" (mouseenter)="showNavTooltip($event, 'Requests')" (mouseleave)="hideNavTooltip()">
            <button class="nav-item" [class.active]="activeNav === 'requests'" [class.locked]="navLocked"
              [disabled]="navLocked" [attr.title]="navLocked ? 'Create a project to unlock this section' : null"
              (click)="setActiveNav('requests')">
              <lucide-icon name="ticket" [size]="18" class="nav-ic" />
              <span class="nav-label">Requests</span>
              @if (navLocked) {
              <lucide-icon name="lock" [size]="12" class="nav-lock-icon" style="display: flex;"></lucide-icon>
              }
            </button>
          </div>
          <div class="nav-item-wrap" (mouseenter)="showNavTooltip($event, 'Sites Updates')"
            (mouseleave)="hideNavTooltip()">
            <button class="nav-item" [class.active]="activeNav === 'sites'" [class.locked]="navLocked"
              [disabled]="navLocked" [attr.title]="navLocked ? 'Create a project to unlock this section' : null"
              (click)="setActiveNav('sites')">
              <lucide-icon name="globe" [size]="18" class="nav-ic" />
              <span class="nav-label">Sites Updates</span>
              @if (navLocked) {
              <lucide-icon name="lock" [size]="12" class="nav-lock-icon" style="display: flex;"></lucide-icon>
              }
            </button>
          </div>
          <div class="coming-soon-container">
            <div class="coming-soon-item" (mouseenter)="showNavTooltip($event, 'Workflows (coming soon)')"
              (mouseleave)="hideNavTooltip()">
              <button class="nav-item" [class.locked]="navLocked" [disabled]="navLocked"
                [attr.title]="navLocked ? 'Create a project to unlock this section' : null">
                <lucide-icon name="network" [size]="18" />
                <span class="nav-label">Workflows</span>
                @if (navLocked) {
                <lucide-icon name="lock" [size]="12" class="nav-lock-icon" style="display: flex;"></lucide-icon>
                }
              </button>
              <span class="coming-soon-label">Coming soon</span>
            </div>
            <div class="coming-soon-item" (mouseenter)="showNavTooltip($event, 'AEO (coming soon)')"
              (mouseleave)="hideNavTooltip()">
              <button class="nav-item" [class.locked]="navLocked" [disabled]="navLocked"
                [attr.title]="navLocked ? 'Create a project to unlock this section' : null">
                <lucide-icon name="message-square-more" [size]="18" />
                <span class="nav-label">AEO</span>
                @if (navLocked) {
                <lucide-icon name="lock" [size]="12" class="nav-lock-icon" style="display: flex;"></lucide-icon>
                }
              </button>
              <span class="coming-soon-label">Coming soon</span>
            </div>
          </div>
        </nav>

        <div class="sidebar-spacer"></div>

        <nav class="side-nav side-nav-muted">
          <button class="nav-item" [class.active]="settingsModalOpen" (click)="setActiveNav('settings')"
            (mouseenter)="showNavTooltip($event, 'Settings')" (mouseleave)="hideNavTooltip()">
            <lucide-icon name="settings" [size]="18" class="nav-ic" />
            <span class="nav-label">Settings</span>
          </button>
          <a class="nav-item" href="https://studio-enova.notion.site/309c49c5819b8032b3cac113bac79f34?pvs=105"
            target="_blank" rel="noopener noreferrer" (mouseenter)="showNavTooltip($event, 'Help & Support')"
            (mouseleave)="hideNavTooltip()">
            <lucide-icon name="circle-question-mark" [size]="18" class="nav-ic" />
            <span class="nav-label">Help & Support</span>
          </a>
        </nav>
      </div>

    </div>

    <!-- User footer — outside sidebar-scroll so the dropdown is not clipped by overflow-y:auto.
         Identity has a known shape and always resolves to something, so it gets a skeleton
         rather than an empty gap or, as before, a name mirrored out of localStorage. -->
    <div class="user-footer">
      @if (session.isResolving()) {
      <div class="user-footer__loading" aria-busy="true">
        <span class="dk-visually-hidden">Loading your account</span>
        <span class="dk-skeleton user-footer__loading-avatar" aria-hidden="true"></span>
        <span class="user-meta" aria-hidden="true">
          <span class="dk-skeleton dk-skeleton--text user-footer__loading-name"></span>
          <span class="dk-skeleton dk-skeleton--text user-footer__loading-email"></span>
        </span>
      </div>
      } @else {
      <app-user-menu dropdownPosition="top-left">
        <span class="user-meta">
          <span class="user-name">{{ session.userName() }}</span>
          <span class="user-email" [title]="session.userEmail()">{{ session.userEmail() }}</span>
        </span>
      </app-user-menu>
      }
    </div>
  </aside>

  <main class="main-content">

    <!-- Header -->
    <header class="content-header">
      <div class="header-left">
        <button class="mobile-nav-toggle" (click)="toggleMobileNav()" [class.active]="mobileNavOpen"
          aria-label="Open navigation">
          <lucide-icon name="menu" [size]="20" />
        </button>
        @if (isStaging) {
        <span class="env-badge env-badge--staging" aria-label="Entorno de staging">Staging</span>
        }
      </div>
    </header>

    <div class="content-area">
      <div class="content-area__header">
        @let crumbs = pageBreadcrumbService.crumbs();
        @if (crumbs.length) {
        <!-- Each level links back to itself by running the back action of the crumb after it. -->
        <nav class="content-area__breadcrumb" aria-label="Breadcrumb">
          <button type="button" class="content-area__breadcrumb-link" (click)="crumbs[0].onBack()">{{ pageTitle }}</button>
          @for (crumb of crumbs; track $index; let last = $last) {
          <lucide-icon name="chevron-right" [size]="14" class="content-area__breadcrumb-sep" aria-hidden="true" />
          @if (crumb.select; as select) {
          <app-dashboard-project-select [projects]="select.options" [value]="select.value"
            (selected)="select.onSelect($event)" />
          } @else {
          @if (crumb.icon) {
          <span class="content-area__breadcrumb-icon" [class.has-logo]="crumb.icon.logoUrl"
            [style.background-color]="crumb.icon.logoUrl ? null : (crumb.icon.color || '#5F42D9')" aria-hidden="true">
            @if (crumb.icon.logoUrl) {
            <img [src]="crumb.icon.logoUrl" alt="" />
            } @else {
            <span>{{ crumb.icon.initials }}</span>
            }
          </span>
          }
          @if (last) {
          <span class="content-area__breadcrumb-current" aria-current="page">{{ crumb.label }}</span>
          } @else {
          <button type="button" class="content-area__breadcrumb-link" (click)="crumbs[$index + 1].onBack()">{{ crumb.label }}</button>
          }
          }
          }
        </nav>
        } @else {
        @if (showProjectSelector) {
        <app-project-selector [projects]="projects" />
        } @else {
        <p>{{ pageTitle }}</p>
        }
        }
        <div class="content-area__header-actions">
          <project-search />
          <button class="notif-bell" type="button" [class.is-open]="notificationsOpen" (click)="toggleNotifications()"
            aria-label="Notifications">
            <lucide-icon name="bell" [size]="20" style="display: flex;"></lucide-icon>
            <span class="notif-bell-label">Notifications</span>
            @if (notificationService.hasUnread()) {
            <span class="notif-badge">{{ notificationService.unreadCount() }}</span>
            }
          </button>
        </div>
      </div>
      <div class="content-area__body" #contentBody>
        <router-outlet />
      </div>
    </div>

    <!-- Notifications side panel — slides in from the right edge of the white window -->
    <div class="notif-side-panel" [class.open]="notificationsOpen">
      <app-notifications-panel (closePanel)="closeNotifications()" />
    </div>
  </main>
</div>

@if (navTooltip(); as tooltip) {
<div class="sidebar-tooltip" [style.top.px]="tooltip.top" [style.left.px]="tooltip.left">{{ tooltip.text }}</div>
}

<app-settings-modal [isOpen]="settingsModalOpen" (closeModal)="closeSettingsModal()" [projects]="projects"
  [initialSection]="pendingSettingsSection" [initialProjectId]="pendingSettingsProjectId"
  [initialIntegration]="pendingSettingsIntegration" [initialSlackWorkspaceLinkId]="pendingSettingsWorkspaceLinkId"
  (projectRemoved)="onProjectRemoved($event)" />

<app-create-project-panel [isOpen]="createPanelOpen" [editProject]="editingProject" (closePanel)="onCloseCreatePanel()"
  (projectCreated)="onProjectCreated($event)" (projectUpdated)="onProjectUpdated($event)" />
